import Moment from 'moment';
import Handlebars from 'handlebars/dist/cjs/handlebars';
import { getModuleId } from './config';

export function registerHandlebarsHelpers() {
    Handlebars.registerHelper("increment", (value, options) => {
        return parseInt(value) + 1;
    });

    Handlebars.registerHelper("moduleId", () => {
        return getModuleId();
    });

    // Check if two values are equal
    Handlebars.registerHelper('ifEqual', function (param1, param2, options) {
        var fnTrue = options.fn,
            fnFalse = options.inverse;

        return param1 === param2 ? fnTrue(this) : fnFalse(this);
    });

    // Check if two values are not equal
    Handlebars.registerHelper('ifNotEqual', function (param1, param2, options) {
        var fnTrue = options.fn,
            fnFalse = options.inverse;

        return param1 !== param2 ? fnTrue(this) : fnFalse(this);
    });

    // Format the date to the given format
    Handlebars.registerHelper('formatDate', function (dateVar, format) {
        var date = Moment(dateVar);

        return date.format(format.toUpperCase());
    });
}
